import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	ZaznamId: null as number | null,
	SkladpneuOzn: null as number | null,
	ProvozovnaId: null as number | null,
	StrednaklOzn: null as number | null,
	BlokacePrp: null as boolean | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	PsmKapacita: null as number | null,
	PradaPocet: null as number | null,
	PsloupecPocet: null as number | null,
	PvyskaPocet: null as number | null,
	Text: null as string | null,
	PneuSzb: null as number | null,
	DmstextId: null as number | null,
	DmstextIdText: null as string | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaIdText: [],
		StrednaklOznIdText: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.SKLAD_PNEU_TEXTY_SELECT_MAPPER](state, { data }) {
			state.edit.DmstextId = data.value;
			state.edit.DmstextIdText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
